import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=e9dec3f2&scoped=true"
import script from "./pager.vue?vue&type=script&lang=js"
export * from "./pager.vue?vue&type=script&lang=js"
import style0 from "./pager.vue?vue&type=style&index=0&id=e9dec3f2&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dec3f2",
  null
  
)

export default component.exports